import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import Group from 'components/utils/Group'
import Modal from 'LuxKit/Modal/Modal'
import type { ModalFooterOnClickHandler } from 'LuxKit/Modal/ModalFooter'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  inclusions: Array<App.OfferInclusion>
  offerName: string
  onViewOffer: () => void
}

function OfferInclusionsModal({ inclusions, offerName, onViewOffer }: Props) {
  const intl = useIntl()

  const handleViewOffer = useCallback<ModalFooterOnClickHandler>((_event, resolve) => {
    resolve()
    onViewOffer()
  }, [onViewOffer])

  const viewOfferLabel = intl.formatMessage({
    id: '0cKWSwyDZvKU0-9U6UrT',
    defaultMessage: 'View offer',
    description: 'Button to view hotel offer details on the hotel or room booking page',
  })

  return (
    <Modal
      title={offerName}
      primaryActionText={viewOfferLabel}
      onPrimaryActionClick={handleViewOffer}
    >
      <Group direction="vertical" gap={4}>
        {inclusions.map((inclusion) => (
          <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />
        ))}
      </Group>
    </Modal>
  )
}

export default OfferInclusionsModal
